import { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import Joyride, { ACTIONS } from 'react-joyride'
import { TourCard } from '../../components'
import { propTypes } from '../../helpers'
import { useAffiliation, useAuth } from '../../hooks'
import { useApplicationName, useImgSrcLogin, usePageState } from '../../store'

const Tour = ({ category, global, steps, runTour, onClose }) => {
  const [joyride, setJoyride] = useState()
  const { loggedIn } = useAuth()
  const applicationName = useApplicationName()
  const imgSrcLogin = useImgSrcLogin()
  const pageState = usePageState()
  const { affiliation } = useAffiliation()
  const permissions = affiliation?.permissions

  const filter = useMemo(
    () => ({
      global,
      applicationName,
      categoryName: category.name,
      categoryType: category.categoryType,
      loggedIn,
      pageState,
      permissions
    }),
    [
      applicationName,
      category.categoryType,
      category.name,
      global,
      loggedIn,
      pageState,
      permissions
    ]
  )

  const filteredSteps = steps
    .filter((step) => {
      if (step.conditions === undefined) {
        return true
      }
      for (const [key, value] of Object.entries(step.conditions)) {
        if (key === 'permission') {
          if (!filter.permissions?.includes(value)) {
            return false
          }
        } else if (filter[key] !== value) {
          return false
        }
      }
      return true
    })
    .map(({ title, content, ...rest }) => {
      const regex = /<<(\w+)>>/g
      const matchFun = (match, capture) => filter[capture] || match
      return {
        ...(title
          ? {
              title: title.replace(regex, matchFun)
            }
          : {}),
        content: content.replace(regex, matchFun),
        ...rest,
        disableBeacon: true
      }
    })

  const handleCallback = ({ action }) => {
    if (ACTIONS.CLOSE === action) {
      joyride.reset(true)
      onClose()
    }
  }

  return (
    <Joyride
      callback={handleCallback}
      continuous
      disableOverlayClose
      disableScrolling
      getHelpers={setJoyride}
      run={runTour}
      steps={filteredSteps}
      tooltipComponent={(props) => (
        <TourCard {...props} imgSrcTour={imgSrcLogin} />
      )}
      styles={{
        options: {
          zIndex: 2000
        }
      }}
    />
  )
}

Tour.propTypes = {
  category: propTypes.categoryPropType,
  global: PropTypes.bool,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired
    })
  ).isRequired,
  runTour: PropTypes.bool,
  onClose: PropTypes.func
}

export { Tour }
